import React from "react";

// 2026-09-13 — StoxTrade brand mark (chat: "Would prefer to change current
// logo...review attached images and change colors according to our app").
// Recolors the user-supplied "execution bolt" design (originally #ff9142 /
// #35c47a) to the app's own "Terminal" theme tokens (see index.css's
// .theme-terminal block): the front bolt uses --bull (#4f9484, muted
// teal-green) and the back bolt + motion lines use --bear (#e2735a, muted
// coral) — the "Bull + bear" option the user picked over a bull+brass
// alternative. Hardcoded hex rather than `var(--bull)`/`var(--bear)` on
// purpose: this asset also needs to render correctly outside the app's own
// CSS context (favicon, email header), where those custom properties
// aren't available.
//
// Kept as a single inline React component (not an <img> tag) so it renders
// crisp at any size with zero extra network request, and so its source
// markup can be copy/reused verbatim for public/logo.svg and a future email
// template — all three should always show the exact same bolt.
export const Logo = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    role="img"
    aria-label="StoxTrade"
  >
    <g stroke="#e2735a" strokeWidth="3" opacity="0.4" strokeLinecap="round">
      <line x1="14" y1="34" x2="28" y2="30" />
      <line x1="12" y1="50" x2="27" y2="48" />
      <line x1="16" y1="66" x2="29" y2="61" />
    </g>
    <path d="M63 13 L35 59 L52 59 L43 93 L81 45 L62 45 Z" fill="#e2735a" />
    <path d="M58 10 L30 56 L47 56 L38 90 L76 42 L57 42 Z" fill="#4f9484" />
  </svg>
);

export default Logo;
